import { render, staticRenderFns } from "./UnansweredMessages.vue?vue&type=template&id=7d531cd8&scoped=true&"
import script from "./UnansweredMessages.vue?vue&type=script&lang=js&"
export * from "./UnansweredMessages.vue?vue&type=script&lang=js&"
import style0 from "./UnansweredMessages.vue?vue&type=style&index=0&id=7d531cd8&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d531cd8",
  null
  
)

export default component.exports